import { useEffect, useState } from 'react'

// A deliberately tiny "loading" beat so screens render brand-colored skeletons
// on first paint instead of popping in. State is in-memory only; the data is
// already present synchronously — this is purely the optimistic-UI shimmer the
// brief asked for (no blocking spinners). Defaults to a single short beat.
export function useBriefLoad(ms = 420): boolean {
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    const t = setTimeout(() => setLoading(false), ms)
    return () => clearTimeout(t)
  }, [ms])
  return loading
}
